import { Text as ThemeUIText } from 'theme-ui';

const Text = (props) => <ThemeUIText {...props}>{props.children}</ThemeUIText>;

export default Text;
